import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en_US from './localization/en_US.json';
import fr_FR from './localization/fr_FR.json';
import de_DE from './localization/de_DE.json';
import it_IT from './localization/it_IT.json';
import ja_JP from './localization/ja_JP.json';

const localeText = { en_US, fr_FR, de_DE, it_IT, ja_JP };

const resources = localeText;
i18n.use(initReactI18next).init({
  resources,
  lng: 'en_US',
  fallbackLng: 'en_US',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
